import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Message } from 'primeng/primeng';
import { RouteService } from '../../../service/route/route.service';
import { Route } from '../../../class/route';

@Component({
  selector: 'app-route',
  templateUrl: './route.component.html',
  styleUrls: ['./route.component.scss']
})
export class RouteComponent implements OnInit {
    @Output() msg: EventEmitter<object> = new EventEmitter<object>();
    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() infoRoute: Route;
    public route: Route;
    public msgs: Message[] = [];
    public options: any;

    constructor(
        public routeService: RouteService,
        private activatedRoute: ActivatedRoute) {
    }

    ngOnInit() {
    }

    public cancelRoute () {
        this.close.emit(true);
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/routes/route/route.component.ts